export default {
  userInfo:{},
  token:{},
  isMenuShow:true,
  menuList:{},
  menuSelect:[]
}